module.exports = __webpack_public_path__ + "static/img/figma.aba09ad3.svg";